import { default as domainGrid } from './grid/services' 

export default { 
	domainGrid 
}
